import { useV2UpdateNotificationMutation } from "@generated";

// Shared by anywhere a notification's "View" link is rendered
const useMarkNotificationRead = () => {
  const [updateNotification] = useV2UpdateNotificationMutation();

  const handleView = async (
    e: React.MouseEvent,
    id: string | undefined,
    link: string
  ) => {
    e.preventDefault();

    if (!id) {
      window.location.href = link;
      return;
    }

    try {
      await updateNotification({
        id,
        body: {
          data: {
            id,
            type: "notifications",
            attributes: { "read-at": new Date().toISOString() },
          },
        },
      }).unwrap();
    } catch {
      // no-op — still navigate below
    } finally {
      window.location.href = link;
    }
  };

  return handleView;
};

export default useMarkNotificationRead;
